export default __webpack_public_path__ + "static/media/shirtly_ipad_1.1cb4ec79.png";